import React from "react";
import { LoanRequestsPendingApprovalContainer } from "../../../containers";
import { ManageDistributionProvider } from "../../../contexts";

const LoanRequestsPendingApproval = (props) => {
  return (
    <ManageDistributionProvider>
      <LoanRequestsPendingApprovalContainer {...props} />
    </ManageDistributionProvider>
  );
};

export default LoanRequestsPendingApproval;
